import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteIcbperFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='ICBPER' htmlFor='input-importeIcbper' md={12} />
      <Col md={12}>
        <Form.InputNumber
          id='input-importeIcbper'
          name='input-importeIcbper'
          value={iValue}
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteIcbperFormGroup)
